import {
  configureCheckboxActionButton,
  configureCheckAllCheckbox,
} from '../../components/checkbox'
import { initExportModal } from '../../components/studylink_support/export_modal'

function initBranchList() {
  const buttonExportSelected = document.getElementById(
    'btn-export-selected',
  ) as HTMLButtonElement
  const checkboxes = document.getElementsByName(
    'branch',
  ) as NodeListOf<HTMLInputElement>
  const checkAll = document.getElementById('check-all') as HTMLInputElement
  configureCheckboxActionButton(buttonExportSelected, checkboxes)
  configureCheckAllCheckbox(checkAll, checkboxes, buttonExportSelected)
  initExportModal()
}

export { initBranchList }
